module.exports = __webpack_public_path__ + "static/media/portada.45c9c955.png";